import { Selecao } from "./illustrations/selecao";
import { SemDados } from "./illustrations/sem-dados";
import { SemEquipe } from "./illustrations/sem-equipe";
import { SemFiltros } from "./illustrations/sem-filtros";
import { SemResultados } from "./illustrations/sem-resultados";
import { TipoObras } from "./illustrations/tipo-obras";
import type { Art, IllustrationName } from "./types-illustration";

export const ILLUSTRATION_ARTS: Record<IllustrationName, Art> = {
  "sem-resultados": { Component: SemResultados, figma: "ilu-no-search", viewBox: "0 0 216 113" },
  "sem-filtros": { Component: SemFiltros, figma: "ilu-no-filters", viewBox: "0 0 216 113" },
  "sem-dados": { Component: SemDados, figma: "ilu-no-charts", viewBox: "0 0 216 113" },
  selecao: { Component: Selecao, figma: "ilu-select-dropdown", viewBox: "0 0 213 107.28" },
  "tipo-obras": { Component: TipoObras, figma: "ilu-type-obras", viewBox: "0 0 197 98.04" },
  "sem-equipe": { Component: SemEquipe, figma: "ilustração (4762:68515)", viewBox: "0 0 128 61" },
};
